import React from 'react';
import '../styles/AboutPage.css';
//import Lottie from 'lottie-react';
//import anime1 from '../animations/anime5.json';

const AboutUs = () => {
    return (
        <div className="about-container">
            {/* Hero
            <section className="about-hero">
                <div className="overlay"></div>
                <div className="about-hero-content">
                    <Lottie animationData={anime1} loop={true} className="about-animation"
                            style={{width: '75%', height: '75%'}}/>

                </div>
            </section>*/}

            {/* Content Sections */}
            <section className="about-section">
                <div className="about-content">
                    <h2>Hakkımızda</h2>
                    <p>
                        <section id="meduvr">
                            <strong>MeduVR ve Radyolojide Sanal Gerçeklik (RSG)</strong>
                            <p>
                                <strong>MeduVR</strong>, özellikle meme sağlığı, erken tanı ve tarama süreçlerine
                                odaklanan;
                                kullanıcıların bu konuları uygulamalı olarak deneyimlemesini sağlayan, Türkiye’nin ilk
                                sanal gerçeklik tabanlı tıbbi eğitim platformudur.
                            </p>
                            <p>
                                Bu platformun temel amacı, meme kanseri taramalarında erken tanının önemini vurgulamak,
                                halkı bilinçlendirmek
                                ve sağlık profesyonellerine klinik alanda uygulanabilir, güvenli ve tekrarlanabilir bir
                                eğitim ortamı sunmaktır.
                            </p>
                            <p>
                                MeduVR, kadınlara yönelik halk sağlığı temelli çalışmaları kapsamında geliştirdiği sanal
                                senaryolarla:
                            </p>
                            <ul>
                                <li>Kendi kendine meme muayenesi (KKMM)</li>
                                <li>Klinik meme muayenesi (KMM)</li>
                                <li>Mamografi öncesi bilgilendirme</li>
                                <li>Mamografi pozisyonlama eğitimi</li>
                                <li>Gerçek hastane ortamında tüm süreçleri defalarca deneyimleme pratiği</li>
                            </ul>
                            <p>
                                Sistem yalnızca temel düzeyde bilgi aktarmakla kalmaz; aynı zamanda sağlık
                                çalışanlarının teknik beceri kazanımını da destekler.
                                Kullanıcılar, simülasyon ortamında hem temel çekim teknikleri olan <strong>Kraniyokaudal
                                (CC)</strong> ve
                                <strong>Mediolateral Oblik (MLO)</strong> pozisyonlarını hem de ileri görüntüleme
                                yöntemlerini uygulamalı olarak deneyimleyebilir.
                            </p>
                            <p>Bu ileri teknikler arasında:</p>
                            <ul>
                                <li>Spot kompresyon</li>
                                <li>Büyütme çekimi</li>
                                <li>Tanjensiyel görüntüleme</li>
                                <li>Cleavage ve LM/ML çekimler</li>
                                <li>İmplantlı bireylerde Eklund tekniği</li>
                            </ul>
                            <p>Platformun hedef grupları:</p>
                            <ul>
                                <li>👩‍👧‍👧 Toplum bireyleri (özellikle 18–74 yaş arası kadınlar)</li>
                                <li>🎓 Sağlık Bilimleri ve Tıbbi Görüntüleme Teknikleri öğrencileri</li>
                                <li>🎓 Üniversite öğrencileri</li>
                                <li>👩‍⚕️ Sağlık profesyonelleri</li>
                                <li>🏥 Hastanelerin Radyoloji, Meme Poliklinikleri, Hemşirelik Hizmetleri ünitelerinde
                                    görev yapan profesyonel ve uzmanlar
                                </li>
                            </ul>
                            <p>
                                Bu gruplara özel hazırlanan senaryolar, kullanıcıların halk sağlığı temelli farkındalık
                                kazanmasını, klinik becerilerini geliştirmesini
                                ve sanal ortamda güvenle tekrar yapabilmesini sağlar.
                            </p>
                            <p>
                                MeduVR’nin gelişim süreci 2018 yılında Doç. Dr. Nuran Akyurt tarafından başlatılmış ve
                                Marmara Üniversitesi'nin akademik desteğiyle ilk projelendirmeler gerçekleştirilmiştir.
                            </p>
                            <p>
                                Zamanla BABKO, MİTTO, Bayer G4A, KOSGEB, TÜBİTAK ve ADEP gibi kurumların destekleriyle
                                platform, yalnızca akademik bir çalışma olmaktan çıkmış;
                                ticarileştirilmiş, yaygınlaştırılmış ve sürdürülebilir dijital bir eğitim çözümüne
                                dönüşmüştür.
                            </p>
                            <p>Bugün MeduVR:</p>
                            <ul>
                                <li>Kadın sağlığına odaklanan halk sağlığı projeleri</li>
                                <li>VR teknolojisi ile radyasyon maruziyeti olmadan uygulama yapabilme</li>
                                <li>Simülasyon ortamında hata yapma korkusu olmadan deneyim kazanma</li>
                                <li>Eğitimde dijital dönüşümün uygulanabilir örneklerinden biri olma</li>
                            </ul>
                            <p>
                                Sağlık eğitiminin dijitalleştirilmesini hedefleyen MeduVR, kullanıcılarına pratik,
                                güvenli ve kişiselleştirilebilir bir öğrenme deneyimi sunarak
                                hem mesleki gelişimi hem de halk sağlığını desteklemeye devam etmektedir.
                            </p>
                        </section>
                    </p>

                </div>
            </section>
        </div>
    );
};

export default AboutUs;